import { useRouter } from 'next/router'
import { useEffect, useRef, useState } from 'react'
import { cn } from '@/lib/utils'

const pathOf = (url: string): string => url.split(/[?#]/)[0] || '/'

/** Crossfades page changes through black. */
export const PageTransition = () => {
    const router = useRouter()
    const [covering, setCovering] = useState(false)
    const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

    useEffect(() => {
        const start = (url: string, { shallow }: { shallow: boolean }) => {
            if (shallow) return
            if (pathOf(url) === window.location.pathname) return
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

            if (timer.current) clearTimeout(timer.current)
            setCovering(true)
        }

        const done = () => {
            if (timer.current) clearTimeout(timer.current)
            timer.current = setTimeout(() => setCovering(false), 90)
        }

        router.events.on('routeChangeStart', start)
        router.events.on('routeChangeComplete', done)
        router.events.on('routeChangeError', done)

        return () => {
            router.events.off('routeChangeStart', start)
            router.events.off('routeChangeComplete', done)
            router.events.off('routeChangeError', done)
            if (timer.current) clearTimeout(timer.current)
        }
    }, [router.events])

    return (
        <div
            aria-hidden='true'
            className={cn(
                'pointer-events-none fixed inset-0 z-[80] bg-black transition-opacity',
                covering ? 'opacity-100 duration-300 ease-in' : 'opacity-0 duration-700 ease-out'
            )}
        />
    )
}
